module.exports = __webpack_public_path__ + "img/services-two-2.8e1cc52d.png";